<template>
    <div class="mb-6">
        <button type="button" ref="clos" class="w-close-dialog" @click="closeModal">
            <!-- <i class="fa-sharp fa-light fa-xmark"></i> -->
            <svg viewBox="0 0 24 24" role="img" aria-label="Close" focusable="false" style="height: 16px; width: 16px; fill: rgb(118, 118, 118); position: relative;top: 3px;"><path d="m23.25 24c-.19 0-.38-.07-.53-.22l-10.72-10.72-10.72 10.72c-.29.29-.77.29-1.06 0s-.29-.77 0-1.06l10.72-10.72-10.72-10.72c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l10.72 10.72 10.72-10.72c.29-.29.77-.29 1.06 0s .29.77 0 1.06l-10.72 10.72 10.72 10.72c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22" fill-rule="evenodd"></path></svg>
        </button>
    </div>
</template>

<script>
    export default {
        name: "ButtonCloseModal",
        methods: {
            closeModal() {
                this.$emit('close', true);
            }
        }
    }
</script>
